import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Button } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import appcolors from "../../constants/Colors";

const BackButton = () => {
  const navigate = useNavigate();
  return (
    <Button
      onClick={() => navigate(-1)}
      disableRipple
      variant="outlined"
      sx={{
        border: "none",
        height: "10px",
        width: "100px",
        color: appcolors.slateGrey,
        "&:hover": {
          border: "none",
          backgroundColor: "transparent",
        },
      }}
      startIcon={<ArrowBackIosIcon htmlColor={appcolors.slateGrey} />}
    >
      Back
    </Button>
  );
};

export default BackButton;
